import React, { useEffect } from 'react';
import { Field, Form } from 'react-final-form';
import { Button, ButtonToolbar } from 'reactstrap';
import CustomCheckBox from '../../../components/form/CustomCheckBox';
import { useDict } from '../../../contexts/LanguageContext';
import PlatformAgreementEngPDF from '../../../documents/platform_agreement_EN.pdf';
import PlatformAgreementThaiPDF from '../../../documents/platform_agreement_TH.pdf';
import RiskDisclosureStatementEngPDF from '../../../documents/risk_disclosure_statement_EN.pdf';
import RiskDisclosureStatementThaiPDF from '../../../documents/risk_disclosure_statement_TH.pdf';
import TermsOfServiceEngPDF from '../../../documents/terms_of_service_EN.pdf';
import TermsOfServiceThaiPDF from '../../../documents/terms_of_service_TH.pdf';

const TNC = (props) => {
    const {
        onSubmit,
        previousPage,
        // isCredentialValid,
        // isCredentialInvalid,
        termsAndCondition,
        // submitted,
        isAgree,
        // onVerifyCredential,
    } = props;

    const dict = useDict();

    const language = localStorage.getItem('language') === 'en' ? 'en' : 'th';

    const platformAgreementPDF = language === 'th' ? PlatformAgreementThaiPDF : PlatformAgreementEngPDF;
    const termsOfServicePDF = language === 'th' ? TermsOfServiceThaiPDF : TermsOfServiceEngPDF;
    const riskDisclosureStatementPDF = language === 'th' ? RiskDisclosureStatementThaiPDF : RiskDisclosureStatementEngPDF;

    const openPDFPreview = (pdfFile) => {
        window.open(pdfFile, '_blank');
    };

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <Form
            initialValues={{
                // submitted,
                // email: '',
                is_agree: isAgree,
            }}
            onSubmit={(values) => {
                onSubmit(values);
                // if (isCredentialValid) {
                //     return onSubmit(values);
                // }
                // return onVerifyCredential(values.email);
            }}
        >
            {({ handleSubmit, values }) => (
                <form className="form wizard__form_2" onSubmit={handleSubmit}>
                    <div className="card card-TNC">
                        <div className="card__title">
                            <h4
                                className="bold-text"
                                style={{ fontSize: '16px' }}
                            >
                                {dict.tncTitle}
                            </h4>
                            <h5
                                className="subhead"
                                style={{
                                    color: '#252525',
                                    textAlign: 'justify',
                                }}
                            >
                                {dict.tncText1}
                            </h5>
                            <a className="text-blue cursor-pointer" onClick={() => openPDFPreview(riskDisclosureStatementPDF)}>
                                {dict.riskDisclosureStatement}
                            </a>
                            {' '} | {' '}
                            <a className="text-blue cursor-pointer " onClick={() => openPDFPreview(termsOfServicePDF)}>
                                {dict.termsOfService}
                            </a>
                            {' '} | {' '}
                            <a className="text-blue cursor-pointer" onClick={() => openPDFPreview(platformAgreementPDF)}>
                                {dict.platformAgreement}
                            </a>
                            <h5
                                className="subhead"
                                style={{ color: '#252525' }}
                            >
                                [ {dict.tncText2} ]
                            </h5>
                        </div>
                        <div className="card__body">
                            <h5
                                className="bold-text"
                                style={{
                                    fontSize: '12px',
                                    textDecoration: 'underline',
                                    marginTop: '-25px',
                                }}
                            >
                                {dict.agreementAndDeclaration}
                            </h5>
                            <h5
                                className="bold-text"
                                style={{ fontSize: '12px', marginTop: '5px' }}
                            >
                                {dict.tncTitle2}
                            </h5>
                            <h5
                                className="bold-text"
                                style={{ fontSize: '12px', marginTop: '15px' }}
                            >
                                {dict.tncSubtitle1}
                            </h5>
                            <p className="underline-text" style={{ textAlign: 'justify' }}>
                                {dict.tncSubtitle1Text1}
                            </p>
                            <p style={{ textAlign: 'justify' }}>
                                {dict.tncSubtitle1Text2}
                            </p>
                            <p style={{ textAlign: 'justify' }}>
                                {dict.tncSubtitle1Text3}
                            </p>
                            <p style={{ textAlign: 'justify' }}>
                                {dict.tncSubtitle1Text4}
                            </p>
                            <ul>
                                <li>{dict.tncSubtitle1Text4List1}</li>
                                <li>{dict.tncSubtitle1Text4List2}</li>
                                <li>{dict.tncSubtitle1Text4List3}</li>
                            </ul>
                            <p style={{ textAlign: 'justify' }}>
                                {dict.tncSubtitle1Text5}
                            </p>
                            <p style={{ textAlign: 'justify' }}>
                                {dict.tncSubtitle1Text6}
                            </p>
                            <h5
                                className="bold-text"
                                style={{ fontSize: '12px', marginTop: '15px' }}
                            >
                                {dict.tncSubtitle2}
                            </h5>
                            <p style={{ textAlign: 'justify' }}>
                                {dict.tncSubtitle2Text1}
                            </p>
                            <p style={{ textAlign: 'justify' }}>
                                {dict.tncSubtitle2Text2}
                            </p>
                            <p style={{ textAlign: 'justify' }}>
                                {dict.tncSubtitle2Text3}
                            </p>
                            <h5
                                className="bold-text"
                                style={{ fontSize: '12px', marginTop: '15px' }}
                            >
                                {dict.tncSubtitle3}
                            </h5>
                            <p style={{ textAlign: 'justify' }}>
                                {dict.tncSubtitle3Text1}
                            </p>
                            <h5
                                className="bold-text"
                                style={{ fontSize: '12px', marginTop: '15px' }}
                            >
                                {dict.tncSubtitle4}
                            </h5>
                            <p style={{ textAlign: 'justify' }}>
                                {dict.tncSubtitle4Text1}
                            </p>
                            <h5
                                className="bold-text"
                                style={{ fontSize: '12px', marginTop: '15px' }}
                            >
                                {dict.tncSubtitle5}
                            </h5>
                            <p style={{ textAlign: 'justify' }}>
                                {dict.tncSubtitle5Text1}
                            </p>
                            <h5
                                className="bold-text"
                                style={{ fontSize: '12px', marginTop: '15px' }}
                            >
                                {dict.tncSubtitle6}
                            </h5>
                            <p style={{ textAlign: 'justify' }}>
                                {dict.tncSubtitle6Text1}
                            </p>
                            <p style={{ textAlign: 'justify' }}>
                                {dict.tncSubtitle6Text2}
                            </p>
                            <h5
                                className="bold-text"
                                style={{ fontSize: '12px', marginTop: '15px' }}
                            >
                                {dict.tncSubtitle7}
                            </h5>
                            <p style={{ textAlign: 'justify' }}>
                                {dict.tncSubtitle7Text1}
                            </p>
                            <p style={{ textAlign: 'justify' }}>
                                {dict.tncSubtitle7Text2}
                            </p>
                            <h5
                                className="bold-text"
                                style={{ fontSize: '12px', marginTop: '15px' }}
                            >
                                {dict.tncSubtitle8}
                            </h5>
                            <p style={{ textAlign: 'justify' }}>
                                {dict.tncSubtitle8Text1}
                            </p>
                            <h5
                                className="bold-text"
                                style={{ fontSize: '12px', marginTop: '15px' }}
                            >
                                {dict.tncSubtitle9}
                            </h5>
                            <p style={{ textAlign: 'justify' }}>
                                {dict.tncSubtitle9Text1}
                            </p>
                            <div
                                className="form__form-group"
                                style={{
                                    border: 'dotted 1px #afafaf',
                                    marginTop: '-10px',
                                }}
                            >
                                <div className="form__form-group-field form-radio-div">
                                    <Field name="is_agree" type="checkbox">
                                        {({ input, meta }) => (
                                            <CustomCheckBox
                                                input={input}
                                                meta={meta}
                                                defaultChecked={
                                                    values.is_agree
                                                }
                                                label={dict.tncAgreeCheckboxText}
                                                // submitted={values.submitted}
                                                data-cy="tnc__agreeCheckbox"
                                            />
                                        )}
                                    </Field>
                                </div>
                            </div>
                            {/* {values.is_agree && (
                                <div>
                                    {isCredentialInvalid && (
                                        <Alert
                                            color="danger"
                                            className="alert--colored"
                                            icon
                                        >
                                            <p style={{ marginTop: '10px' }}>
                                                <span className="bold-text">
                                                    Invalid!
                                                </span>{' '}
                                                Your credentials are invalid.
                                                Please enter valid credentials
                                                to continue!
                                            </p>
                                        </Alert>
                                    )}
                                    {isCredentialValid && (
                                        <Alert
                                            color="success"
                                            className="alert--colored"
                                            icon
                                        >
                                            <p style={{ marginTop: '10px' }}>
                                                <span className="bold-text">
                                                    Valid!
                                                </span>{' '}
                                                Your credentials are valid!
                                                Please proceed to the Submit
                                                button.
                                            </p>
                                        </Alert>
                                    )}
                                    <div className="form__form-group">
                                        <span className="form__form-group-label">
                                            Email
                                        </span>
                                        <div className="form__form-group-field">
                                            <div className="form__form-group-icon">
                                                <Icon icon="At" />
                                            </div>
                                            <Field name="email">
                                                {({ input, meta }) => (
                                                    <CustomInputField
                                                        input={input}
                                                        meta={meta}
                                                        type="email"
                                                        placeholder="example@mail.com"
                                                        autoFocus={
                                                            values.is_agree
                                                        }
                                                        submitted={
                                                            isCredentialValid
                                                        }
                                                        style={{}}
                                                        data-cy="tnc__email"
                                                    />
                                                )}
                                            </Field>
                                        </div>
                                    </div>
                                    {isCredentialValid === false && (
                                        <div
                                            style={{
                                                float: 'left',
                                                textAlign: 'center',
                                            }}
                                        >
                                            <Button
                                                className="rounded"
                                                size="sm"
                                                color="success"
                                                type="submit"
                                                data-cy="tnc__verifyBtn"
                                            >
                                                Verify
                                            </Button>
                                        </div>
                                    )}
                                </div>
                            )} */}
                        </div>
                        <ButtonToolbar className="form__button-toolbar wizard__toolbar">
                            <Button
                                color="primary"
                                type="button"
                                className="previous btn_uni rounded"
                                onClick={previousPage}
                            >
                                {dict.back}
                            </Button>
                            <Button
                                color="primary"
                                type="submit"
                                disabled={
                                    // !isCredentialValid || !values.is_agree
                                    !values.is_agree
                                }
                                className="btn btn_uni submit rounded"
                                data-cy="tnc__submitBtn"
                            >
                                {dict.submit}
                            </Button>
                            {/* {submitted ? (
                                <Button
                                    color="primary"
                                    type="submit"
                                    className="submit btn btn-outline-primary btn_uni rounded"
                                >
                                    Next
                                </Button>
                            ) : (
                                <Button
                                    color="primary"
                                    type="submit"
                                    disabled={
                                        !isCredentialValid || !values.is_agree
                                    }
                                    className="btn btn_uni submit rounded"
                                    data-cy="tnc__submitBtn"
                                >
                                    Submit
                                </Button>
                            )} */}
                        </ButtonToolbar>
                    </div>
                </form>
            )}
        </Form>
    );
};

export default TNC;
